import { $host, $authHost } from './index';

export const fetchTypes = async () => {
    const { data } = await $host.get('/api/type');
    return data;
};

export const fetchBrands = async () => {
    const { data } = await $host.get('/api/brand');
    return data;
};

export const fetchDevices = async (typeId, brandId, page, limit) => {
    const { data } = await $host.get('/api/device', {
        params: { 
            typeId: typeId || null, 
            brandId: brandId || null, 
            page: page || 1, 
            limit: limit || 15 
        }
    });
    return data;
};

export const fetchOneDevice = async (id) => {
    const { data } = await $host.get(`/api/device/${id}`);
    return data;
};

export const createType = async (type) => {
    console.log('📦 createType вызван с:', type);
    try {
        const response = await $authHost.post('/api/type', type);
        console.log('✅ createType ответ:', response);
        return response.data;
    } catch (error) {
        console.error('❌ createType ошибка:', error);
        console.error('❌ Ответ сервера:', error.response);
        throw error;
    }
};

export const createBrand = async (brand) => {
    console.log('📦 createBrand вызван с:', brand);
    try {
        const response = await $authHost.post('/api/brand', brand);
        console.log('✅ createBrand ответ:', response);
        return response.data;
    } catch (error) {
        console.error('❌ createBrand ошибка:', error);
        console.error('❌ Ответ сервера:', error.response);
        throw error;
    }
};

export const createDevice = async (device) => {
    console.log('📦 createDevice вызван с:', device);
    try {
        const response = await $authHost.post('/api/device', device);
        console.log('✅ createDevice ответ:', response);
        return response.data;
    } catch (error) {
        console.error('❌ createDevice ошибка:', error);
        console.error('❌ Ответ сервера:', error.response);
        throw error;
    }
};

export const deleteDevice = async (id) => {
    console.log('🗑️ deleteDevice вызван с id:', id);
    try {
        const response = await $authHost.delete(`/api/device/${id}`);
        console.log('✅ deleteDevice ответ:', response);
        return response.data;
    } catch (error) {
        console.error('❌ deleteDevice ошибка:', error);
        console.error('❌ Ответ сервера:', error.response);
        throw error;
    }
};
